export default "__VITE_ASSET__C$E_kEfD__"